module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('multiselect', _vm._g(_vm._b({
    ref: "multiselect",
    attrs: {
      "options-limit": _vm.renderLimit
    },
    scopedSlots: _vm._u([_vm._l((_vm.$slots), function(_, slotName) {
      return {
        key: slotName,
        fn: function() {
          return [_vm._t(slotName)]
        },
        proxy: true
      }
    })], null, true)
  }, 'multiselect', _vm.$attrs, false), _vm.listeners))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-24ca9093!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/generic/InfiniteMultiselect.vue
// module id = S9p8
// module chunks = 0 1